import * as subscriptionApi from './subscriptionApi';

/* exporta todas as funções da API como default */
/* eslint-disable import/no-anonymous-default-export */
export default {
  ...subscriptionApi,
};
